import { ProductDto } from "@custom-types/products"
import ProductLabel from "@features/administration/products/SelectProduct/ProductLabel"
import { MenuItem, Select, SelectProps } from "@mui/material"
import { GridRowId, useGridApiContext } from "@mui/x-data-grid"
import { useLayoutEffect, useRef } from "react"

type SelectProductProps = SelectProps & {
  products: ProductDto[]
  value: string
  hasFocus?: boolean
  field: string
  gridRowId: GridRowId
}

const SelectProduct = ({
  products,
  value,
  hasFocus,
  field,
  gridRowId,
  ...props
}: SelectProductProps) => {
  const ref = useRef<HTMLInputElement>()
  const apiRef = useGridApiContext()

  useLayoutEffect(() => {
    if (hasFocus) ref?.current?.focus()
  }, [hasFocus])

  const [organisationKey, divisionKey, productKey] = value.split("#")
  const selectedProduct = products.find(
    (product) =>
      organisationKey === product.organisation_key &&
      product.division_key === divisionKey &&
      productKey === product.key,
  )

  return (
    <Select
      fullWidth
      value={value}
      ref={ref}
      renderValue={() => <ProductLabel product={selectedProduct} />}
      onChange={({ target: { value } }) => {
        apiRef.current.setEditCellValue({ id: gridRowId, field, value })

        // clear family value as each product has its own families, so previous value becomes invalid
        apiRef.current.setEditCellValue({ id: gridRowId, field: "family", value: "" })
      }}
      {...props}
    >
      {products.map((product) => (
        <MenuItem
          key={product.key}
          value={`${product.organisation_key}#${product.division_key}#${product.key}`}
        >
          <ProductLabel product={product} />
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectProduct
